import { memo, useEffect, useRef, useState } from "react";
import {
    TransformWrapper,
    TransformComponent,
    useControls,
} from "react-zoom-pan-pinch";
import { Modal } from 'react-bootstrap';
import fullScreenimg from '../../assets/images/full-screen.png'
import TranslateFile from "../../Loc/TranslateFile";
import Envelope from "../../pages/E_Card/GiftEnvelope";
import Button from "./ui/Button";

const CustomEcard = ({
    rotation,
    setRotation,
    setLoading,
    imgsrc,
    isimgrotation = true,
    issendECard = false,
    customized,
    setCustomized,
    envelopecolor = "",
    ecardbgcolor = "",
    rippencolor = "",
    setenvelopecolor,
    setecardbgcolor,
    setrippencolor
}) => {
    const imageRef = useRef(null);
    const { innerWidth: width, innerHeight: height } = window;
    const currentLang = TranslateFile();
    const [isZommImage, setisZommImage] = useState(false);


    // useEffect(() => {
    //     setCustomized(true);
    // }, [issendECard])

    // Function to handle rotation with blur effect
    const handleRotate = (degrees) => {
        setLoading(true);
        const finalRotation = (rotation + degrees) % 360;
        setTimeout(() => {
            setRotation(finalRotation);
            setLoading(false);
        }, 200);
    };

    const Controls = () => {
        const { zoomIn, zoomOut, resetTransform } = useControls();

        return (
            <div class="text-center p-3" style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '15px', backgroundColor: 'black' }}>
                <span className="me-4" style={{ color: 'white' }} onClick={() => zoomIn()}>  <i title={currentLang?.Buttons?.Zoom_In} className='fa-solid fa-magnifying-glass-plus p-1' alt="Zoom In"></i> {currentLang?.Buttons?.Zoom_In}</span>
                <span className="me-4" style={{ color: 'white' }} onClick={() => zoomOut()}> <i title={currentLang?.Buttons?.Zoom_Out} className='fa-solid fa-magnifying-glass-minus p-1' alt="Zoom Out"></i>{currentLang?.Buttons?.Zoom_Out}</span>
                <span className="me-4" style={{ color: 'white' }} onClick={() => { resetTransform(); setRotation(0) }}> <i title={currentLang?.Buttons?.Reset} className='fa-solid fa-arrows-rotate p-1' alt="Reset"></i>{currentLang?.Buttons?.Reset}</span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(90)}> <i title={currentLang?.Buttons?.Rotate_90_Degree} className='fa-solid fa-rotate-right' alt="Rotate 90 Degree"></i></span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(180)}>  <i title={currentLang?.Buttons?.Rotate_180_Degree} className="fa-solid fa-repeat" alt="Rotate 180 Degree"></i></span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => handleRotate(-90)}>   <i title={currentLang?.Buttons?.Rotate_270_Degree} className='fa-solid fa-rotate-left' alt="Rotate 270 Degree"></i></span>

                <span className="me-4" style={{ color: 'white' }} onClick={() => { setisZommImage(false); setRotation(0) }}> <i title={currentLang?.Buttons?.Close} className='fa-solid fa-xmark p-1' alt="Close"></i>{currentLang?.Buttons?.Close}</span>

            </div>
        );
    };

    const ZoomImageComponent = () => {
        return (
            <TransformWrapper >
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <>
                        <Controls />
                        <TransformComponent>
                            <div
                                className="d-flex justify-content-center align-items-center p-2"
                            >
                                <img
                                    onClick={() => { setisZommImage(true) }}
                                    ref={imageRef}
                                    src={imgsrc}
                                    alt="Base64"
                                    style={{
                                        transform: `rotate(${rotation}deg)`,
                                        height: '100%',
                                        objectFit: 'contain', // Ensures the full image is displayed
                                        marginTop: '0', // Adjust margin if needed
                                        maxHeight: '80vh',
                                        minHeight: '80vh',
                                        minWidth: '80vh', maxWidth: '80vh'
                                    }}
                                />
                            </div>
                        </TransformComponent>
                    </>
                )}
            </TransformWrapper>
        );
    };

    return (
        <div >

            {!isZommImage ?

                <div >
                    {((!customized && issendECard) ? <div className="image-rotator" >
                        <div className={!isimgrotation ? "ecard-wrapper" : "image-wrapper"}>
                            {isimgrotation && <div className="rotation-buttons">
                                {/* Rotate 90 Degree */}
                                <button
                                    onClick={() => handleRotate(90)}
                                    title={currentLang?.Buttons?.Rotate_90_Degree}
                                    className="btn btn-danger mrl-10 fs-14 me-2"
                                >
                                    <i className='fa-solid fa-rotate-right' alt="Rotate 90 Degree"></i>
                                </button>
                                <button
                                    onClick={() => handleRotate(180)}
                                    title={currentLang?.Buttons?.Rotate_180_Degree}
                                    className="btn btn-danger mrl-10 fs-14 me-2"
                                >
                                    <i className="fa-solid fa-repeat" alt="Rotate 180 Degree"></i>
                                </button>
                                <button
                                    onClick={() => handleRotate(-90)}
                                    title={currentLang?.Buttons?.Rotate_270_Degree}
                                    className="btn btn-danger mrl-10 fs-14 me-2"
                                >
                                    <i className='fa-solid fa-rotate-left' alt="Rotate 270 Degree"></i>
                                </button>
                            </div>}

                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{
                                    width: isimgrotation ? height - 400 : '100%',
                                    height: isimgrotation ? height - 400 : height - 310,
                                    overflow: 'hidden',
                                    position: 'relative',
                                    marginTop: '30px'
                                }}
                            >
                                <img
                                    onClick={() => { setisZommImage(true) }}
                                    ref={imageRef}
                                    src={imgsrc}
                                    alt="Base64"
                                    style={{
                                        transform: `rotate(${rotation}deg)`,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain', // Ensures the full image is displayed
                                        marginTop: '0', // Adjust margin if needed
                                    }}
                                />
                            </div>
                            {/* <div className="customize-buttons">
                                <Button label={"CUSTOMIZE"} className='me-2' status="success" type="submit" onClick={() => {
                                    setCustomized(true);
                                    setenvelopecolor("#6c6ca8");
                                    setecardbgcolor("#d8d8fb");
                                    setrippencolor("#ff3b3b");
                                }} />
                            </div> */}
                        </div>
                    </div> :
                        <div className="envelopebody">

                            <Envelope
                                imageUrl={imgsrc}
                                setisZommImage={setisZommImage}
                                setCustomized={setCustomized}
                                issendECard={issendECard}
                                envelopecolor={envelopecolor} ecardbgcolor={ecardbgcolor} rippencolor={rippencolor}
                                setenvelopecolor={setenvelopecolor} setecardbgcolor={setecardbgcolor} setrippencolor={setrippencolor}
                            // envelopeColor={data.envelopeColor}
                            // bodyColor={data.bodyColor}
                            // sideColor={data.sideColor}
                            // bottomColor={data.bottomColor}
                            // paperColor={data.paperColor}
                            />
                        </div>
                    )}
                </div>
                :
                <Modal show={isZommImage} size='xl' onHide={() => setisZommImage(false)} centered>
                    <Modal.Body style={{
                        position: 'fixed', top: 0, left: 0,
                        width: '100%', backgroundColor: 'rgb(0 1 14 / 50%)', height: '100%'
                    }}>
                        <ZoomImageComponent />
                    </Modal.Body>
                </Modal>
            }
        </div>
    );
};

export default memo(CustomEcard);
